/**
 * Module NEUTRE « pricing-payment » — KEEP IN SYNC avec
 * inventozen-frontpublic/src/cms-puck/pricing-payment.ts
 *
 * Cible Stripe du bloc PaymentButton (mode + prix instance).
 */

export type PaymentButtonMode = "insertion" | "consultation";

export type StripePaymentTarget = {
  mode: PaymentButtonMode;
  /** ID du prix en base (table Price de l'instance). */
  priceId: string;
};

export const DEFAULT_STRIPE_PAYMENT_TARGET: StripePaymentTarget = {
  mode: "consultation",
  priceId: "",
};

export function normalizePaymentButtonMode(value: unknown): PaymentButtonMode {
  return value === "consultation" ? "consultation" : "insertion";
}

export function normalizeStripePaymentTarget(value: unknown): StripePaymentTarget {
  const o = (value ?? {}) as Partial<StripePaymentTarget>;
  return {
    mode: normalizePaymentButtonMode(o.mode),
    priceId: typeof o.priceId === "string" ? o.priceId.trim() : "",
  };
}
